import { render, staticRenderFns } from "./CustomGdprPopup.vue?vue&type=template&id=531c866c&scoped=true&"
import script from "./CustomGdprPopup.vue?vue&type=script&lang=js&"
export * from "./CustomGdprPopup.vue?vue&type=script&lang=js&"
import style0 from "./CustomGdprPopup.vue?vue&type=style&index=0&id=531c866c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531c866c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('531c866c')) {
      api.createRecord('531c866c', component.options)
    } else {
      api.reload('531c866c', component.options)
    }
    module.hot.accept("./CustomGdprPopup.vue?vue&type=template&id=531c866c&scoped=true&", function () {
      api.rerender('531c866c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/design-components/src/components/CustomGdprPopup.vue"
export default component.exports